
export const defaultVendorAddress = {
    zip: "",
    city: "",
    name: "",
    phone: "",
    state: "",
    country: "",
    address1: "",
    address2: ""
}

export const currencies = [
  { label: "United States Dollar", value: "USD" },
  { label: "United Arab Emirates Dirham", value: "AED" },
  { label: "Afghan Afghani", value: "AFN" },
  { label: "Albanian Lek", value: "ALL" },
  { label: "Armenian Dram", value: "AMD" },
  { label: "Netherlands Antillean Guilder", value: "ANG" },
  { label: "Angolan Kwanza", value: "AOA" },
  { label: "Argentine Peso", value: "ARS" },
  { label: "Australian Dollar", value: "AUD" },
  { label: "Aruban Florin", value: "AWG" },
  { label: "Azerbaijani Manat", value: "AZN" },
  { label: "Bosnia-Herzegovina Convertible Mark", value: "BAM" },
  { label: "Barbadian Dollar", value: "BBD" },
  { label: "Bangladeshi Taka", value: "BDT" },
  { label: "Bulgarian Lev", value: "BGN" },
  { label: "Bahraini Dinar", value: "BHD" },
  { label: "Burundian Franc", value: "BIF" },
  { label: "Bermudian Dollar", value: "BMD" },
  { label: "Brunei Dollar", value: "BND" },
  { label: "Bolivian Boliviano", value: "BOB" },
  { label: "Brazilian Real", value: "BRL" },
  { label: "Bahamian Dollar", value: "BSD" },
  { label: "Botswana Pula", value: "BWP" },
  { label: "Belarusian Ruble", value: "BYN" },
  { label: "Belize Dollar", value: "BZD" },
  { label: "Canadian Dollar", value: "CAD" },
  { label: "Swiss Franc", value: "CHF" },
  { label: "Chilean Peso", value: "CLP" },
  { label: "Chinese Yuan", value: "CNY" },
  { label: "Colombian Peso", value: "COP" },
  { label: "Costa Rican Colón", value: "CRC" },
  { label: "Cuban Convertible Peso", value: "CUC" },
  { label: "Cuban Peso", value: "CUP" },
  { label: "Czech Koruna", value: "CZK" },
  { label: "Danish Krone", value: "DKK" },
  { label: "Dominican Peso", value: "DOP" },
  { label: "Algerian Dinar", value: "DZD" },
  { label: "Egyptian Pound", value: "EGP" },
  { label: "Ethiopian Birr", value: "ETB" },
  { label: "Euro", value: "EUR" },
  { label: "Fiji Dollar", value: "FJD" },
  { label: "British Pound Sterling", value: "GBP" },
  { label: "Ghanaian Cedi", value: "GHS" },
  { label: "Gibraltar Pound", value: "GIP" },
  { label: "Guatemalan Quetzal", value: "GTQ" },
  { label: "Honduran Lempira", value: "HNL" },
  { label: "Hong Kong Dollar", value: "HKD" },
  { label: "Hungarian Forint", value: "HUF" },
  { label: "Indonesian Rupiah", value: "IDR" },
  { label: "Israeli New Shekel", value: "ILS" },
  { label: "Indian Rupee", value: "INR" },
  { label: "Iraqi Dinar", value: "IQD" },
  { label: "Iranian Rial", value: "IRR" },
  { label: "Icelandic Króna", value: "ISK" },
  { label: "Jamaican Dollar", value: "JMD" },
  { label: "Jordanian Dinar", value: "JOD" },
  { label: "Japanese Yen", value: "JPY" },
  { label: "Kenyan Shilling", value: "KES" },
  { label: "Kyrgyzstani Som", value: "KGS" },
  { label: "Cambodian Riel", value: "KHR" },
  { label: "South Korean Won", value: "KRW" },
  { label: "Kuwaiti Dinar", value: "KWD" },
  { label: "Kazakhstani Tenge", value: "KZT" },
  { label: "Lao Kip", value: "LAK" },
  { label: "Lebanese Pound", value: "LBP" },
  { label: "Sri Lankan Rupee", value: "LKR" },
  { label: "Libyan Dinar", value: "LYD" },
  { label: "Moroccan Dirham", value: "MAD" },
  { label: "Moldovan Leu", value: "MDL" },
  { label: "Malagasy Ariary", value: "MGA" },
  { label: "Macedonian Denar", value: "MKD" },
  { label: "Myanmar Kyat", value: "MMK" },
  { label: "Macanese Pataca", value: "MOP" },
  { label: "Mauritian Rupee", value: "MUR" },
  { label: "Maldivian Rufiyaa", value: "MVR" },
  { label: "Mexican Peso", value: "MXN" },
  { label: "Malaysian Ringgit", value: "MYR" },
  { label: "Namibian Dollar", value: "NAD" },
  { label: "Nigerian Naira", value: "NGN" },
  { label: "Nicaraguan Córdoba", value: "NIO" },
  { label: "Norwegian Krone", value: "NOK" },
  { label: "Nepalese Rupee", value: "NPR" },
  { label: "New Zealand Dollar", value: "NZD" },
  { label: "Omani Rial", value: "OMR" },
  { label: "Panamanian Balboa", value: "PAB" },
  { label: "Peruvian Nuevo Sol", value: "PEN" },
  { label: "Philippine Peso", value: "PHP" },
  { label: "Pakistani Rupee", value: "PKR" },
  { label: "Polish Złoty", value: "PLN" },
  { label: "Paraguayan Guaraní", value: "PYG" },
  { label: "Qatari Rial", value: "QAR" },
  { label: "Romanian Leu", value: "RON" },
  { label: "Russian Ruble", value: "RUB" },
  { label: "Rwandan Franc", value: "RWF" },
  { label: "Saudi Riyal", value: "SAR" },
  { label: "Seychellois Rupee", value: "SCR" },
  { label: "Sudanese Pound", value: "SDG" },
  { label: "Swedish Krona", value: "SEK" },
  { label: "Singapore Dollar", value: "SGD" },
  { label: "Syrian Pound", value: "SYP" },
  { label: "Thai Baht", value: "THB" },
  { label: "Tunisian Dinar", value: "TND" },
  { label: "Turkish Lira", value: "TRY" },
  { label: "Trinidad and Tobago Dollar", value: "TTD" },
  { label: "Taiwan Dollar", value: "TWD" },
  { label: "Ukrainian Hryvnia", value: "UAH" },
  { label: "Uruguayan Peso", value: "UYU" },
  { label: "Vietnamese Đồng", value: "VND" },
  { label: "South African Rand", value: "ZAR" }
];
